import { useRegistryData } from "./useRegistryData";

export const useServiceNiceName = (serviceId: string): string => {
  const { data } = useRegistryData();
  return data?.serviceSpecs.find((service) => service.id === serviceId)?.niceName ?? serviceId;
};
